var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMov = function SvgMov(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#1C7ABE",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.17 13.5h1.044l1.101 2.688h.047L7.464 13.5h1.043v4h-.82v-2.604h-.034L6.618 17.48H6.06l-1.036-2.593h-.033V17.5h-.82zm8.874 2q0 .654-.248 1.113a1.7 1.7 0 0 1-.671.701q-.424.24-.954.24-.532 0-.957-.241a1.72 1.72 0 0 1-.67-.702q-.246-.459-.246-1.111 0-.654.246-1.113a1.7 1.7 0 0 1 .67-.7q.425-.242.957-.242.53 0 .954.242.425.24.671.7.249.459.248 1.113m-.857 0q0-.424-.127-.715a.97.97 0 0 0-.354-.441.95.95 0 0 0-.535-.15.95.95 0 0 0-.535.15 1 1 0 0 0-.355.441 1.8 1.8 0 0 0-.125.715q0 .424.125.715a1 1 0 0 0 .355.441q.23.15.535.15a.95.95 0 0 0 .536-.15q.228-.15.353-.441.127-.29.127-.715m2.146-2 .967 3.04h.037l.969-3.04h.937l-1.379 4h-1.09l-1.38-4z"
  })));
};
export default SvgMov;